import { defineMessages } from 'react-intl';

export default defineMessages({
    roofUpdate: {
        "id": "twia.uwIssues.view.Roofing Update",
        "defaultMessage": "Roofing Update"
    },
    addedLivingSpace: {
        "id": "twia.uwIssues.view.Added Living Space - Roofing Updates",
        "defaultMessage": "Added Living Space - Roofing Updates"
    },
    repairsAdditions: {
        "id": "twia.uwIssues.view.Repairs/Additions",
        "defaultMessage": "Repairs/Additions"
    },
    addedLivingSpaceRepairsAddition: {
        "id": "twia.uwIssues.view.Added Living Space - Repairs/Additions",
        "defaultMessage": "Added Living Space - Repairs/Additions"
    },
    coverages:{
        id: "quoteandbind.summary.residential.Location.Coverages",
        defaultMessage: "Coverages"
    },
    coverageDetails:{
        id: "quoteandbind.summary.residential.Location.CoveragesDetails",
        defaultMessage: "Coverages details"
    }
})